export default __webpack_public_path__ + "static/media/e5ec2c357379a05023d563c050fc2e49.svg";